import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import {Label, Select} from '../atoms';

const Container = styled.div`
  padding: 20px;
`;

const LabelledSelect = ({label, placeholder, options}) => (
  <Container>
    <Label style={{marginBottom: '8px'}}>{label}</Label>
    <Select
      options={options}
      classNamePrefix="Select"
      placeholder={placeholder}
      isSearchable={false}
      onChange={() => {}}
    />
  </Container>
);

LabelledSelect.propTypes = {
  label: PropTypes.string,
  placeholder: PropTypes.string,
  options: PropTypes.array
};

export default LabelledSelect;

